import { render } from "./SearchMeal.vue?vue&type=template&id=8fa4cf16&scoped=true"
import script from "./SearchMeal.vue?vue&type=script&lang=js"
export * from "./SearchMeal.vue?vue&type=script&lang=js"

import "./SearchMeal.vue?vue&type=style&index=0&id=8fa4cf16&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa4cf16"]])

export default __exports__